/* eslint-disable max-len */
/* eslint-disable complexity */
import DispatchersMixin from '@/mixins/dispatchers';

export default {
  name: 'TransferOperation',
  mixins: [DispatchersMixin],
  props: {
    newOperationState: {
      type: Object,
      required: true
    },
    transferType: {
      type: String,
      required: true
    },
    productMinimums: {
      type: Object,
      required: true
    },
    nrbeRequired: { 
      type: Boolean, 
      required: false
    }
  },
  /**
   * @override
   */
  data() {
    return {
      timeOutRDTime: 2000,
      timeOutRD: null,
      updatesCount: 0,
      productList: [],
      externalOperationWays: ['TRASPASO_SALIDA', 'TRASPASO_ENTRADA'],
      planTypeOptions: [
        {
          key: 'PPA',
          name: 'PPA'
        },
        {
          key: 'PP',
          name: 'PP'
        }
      ],
      sourceSituationsOptions: [
        {
          key: 'PARTICIPE',
          name: this.$t(`operations.source_situations.PARTICIPE`)
        },
        {
          key: 'BENEFICIARIO',
          name: this.$t(`operations.source_situations.BENEFICIARIO`)
        }
      ],
      compartmentsOptions: [
        {
          key: '1',
          name: this.$t(`operations.compartments['1']`)
        },
        {
          key: '2',
          name: this.$t(`operations.compartments['2']`)
        },
        {
          key: '3',
          name: this.$t(`operations.compartments['3']`)
        }
      ],
      rightsTypesOptions: [
        {
          key: 'C',
          name: this.$t(`operations.rights_types.C`)
        },
        {
          key: 'E',
          name: this.$t(`operations.rights_types.E`)
        },
        {
          key: 'A',
          name: this.$t(`operations.rights_types.A`)
        }
      ],
      collectionMethods: [
        { key: '01', name: this.$t(`operations.tx_collection_methods.1`) },
        { key: '02', name: this.$t(`operations.tx_collection_methods.2`) },
        { key: '03', name: this.$t(`operations.tx_collection_methods.3`) },
        { key: '04', name: this.$t(`operations.tx_collection_methods.4`) }
      ],
      isCustomFund: false,
      searchResults: [],
      multiselectIsLoading: false,
      lastSearch: false,
      timeOutSearch: null,
      timeOutSearchTime: 1000,
      isinValid: false,
      gestorFieldKey: 0,
      isLoadingPensionPlans: false,
      pensionPlansSearchResults: []
    };
  },
  /**
   * @override
   */
  computed: {
    /**
     * @return {Object} Opciones de amount shares indicator
     */
    amountSharesIndicatorOptions() {
      const options = [
        {
          key: 'B',
          name: 'Importe'
        },
        {
          key: 'P',
          name: 'Participaciones'
        }
      ];
      if (this.transferType === 'internal') {
        options.push({ key: 'T', name: 'Total' });
      }
      return options;
    },
    /**
     * @return {Number} minimal amount
     */
    minSuscription() {
      return this.productMinimums.minimum_investment;
    },
    /**
     * @return {Number} minimal amount
     */
    // mínimos del fondo origen
    minToMaintainSource() {
      return Number(this.productMinimums.source.minimum_to_maintain || 0);
    },
    maxInvestmentSource() {
      return Number(this.productMinimums.source.maximum_investment || Infinity);
    },
    // mínimos del fondo destino
    minSubscriptionTarget() {
      if (this.transferType === 'internal' && this.productMinimums.target) {
        return +this.productMinimums.target.minimum_investment;
      }
      return +this.productMinimums.minimum_investment;
    },
    displayCollectionMethodField() {
      return (
        this.newOperationState.operationObj.pp_rights_type &&
        ['A', 'E'].includes(this.newOperationState.operationObj.pp_rights_type.key)
      );
    },
    checkHasMarketers() {
      return (
        !this.newOperationState.operationObj.cnmvObject ||
        (this.newOperationState.operationObj.cnmvObject &&
          this.newOperationState.operationObj.cnmvObject.gestor_name &&
          this.newOperationState.operationObj.cnmvObject.marketers === null)
      );
    },
    correctAndResendMode() {
      let parent = this.$parent;
      while (parent) {
        if (parent.hasOwnProperty('correctAndResendMode')) {
          return parent.correctAndResendMode;
        }
        parent = parent.$parent;
      }
      return false;
    },
    isSpanishFund() {
      const isin = this.newOperationState.operationObj.xt_isin_code ||
        (this.newOperationState.operationObj.cnmvObject && this.newOperationState.operationObj.cnmvObject.isin);
      return !isin || isin.toUpperCase().startsWith('ES');
    }
  },
  methods: {
    /**
     * Función que comprueba el ISIN
     * @param {*} val Valor
     */
    isValidISIN(val) {
      if (val.match(/([A-Z]{2})([A-Z0-9]{9})([0-9]{1})$/)) {
        this.isinValid = true;

        if (this.rejectOwnFund(val)) {
          this.isinValid = false;
          return;
        }

      } else {
        this.isinValid = false;
      }
    },
    /**
     * Función que comprueba si el ISIN corresponde a un fondo propio
     * @param {*} val Valor
     */
    rejectOwnFund(isin) {
      const isOwn = this.newOperationState.productList.some(p => p.isin_code === isin);
      if (isOwn) {
        this.$bvToast.toast('No puede seleccionar un fondo propio como fondo externo.', {
          title: 'ISIN no válido',
          variant: 'danger',
          solid: true
        });
        return true;
      }
      return false;
    },
    /**
     * @override load products function
     */
    loadProducts() {
      const cfg = {};
      this.$productsService.getProducts('', cfg).then(res => {
        this.productList = res.data.products;
        this.productList = this.productList.filter(a => {
          return a.key_name !== this.newOperationState.productSelected.key_name;
        });
      }).catch(err => {
        console.error('Error cargando productos destino:', err);
      });
    },
    /**
     * Chagen amountSharesIndicator
     */
    onChangeamountSharesIndicator() {
      this.newOperationState.operationObj.is_total_transfer =
        this.newOperationState.amountSharesIndicator && this.newOperationState.amountSharesIndicator.key === 'T';
      this.newOperationState.operationObj.shares = null;
      this.newOperationState.operationObj.grossAmount = null;
      // TODO Revisar qué hacemos con este flag para refrescar los campos de valores a la derecha
      // this.newOperationState.keyAddOperation++;
    },
    /**
     * @param {String} grossAmount  gross amount value
     */
    onInputGrossAmount() {
      this.newOperationState.operationObj.shares = 0.0;
    },
    /**
     * @param {String} shares  shares value
     */
    onInputShares() {
      this.newOperationState.operationObj.grossAmount = 0.0;
    },

    /**
     * @param {Object} product object selected
     */
    onSelectTargetProduct(product) {
      // TODO: Mock... como no tenemos valores de los productos, le pongo a pincho que vale 100...
      if (!this.newOperationState.operationObj.product_target.net_asset_value) {
        this.newOperationState.operationObj.product_target.net_asset_value = 100;
        this.newOperationState.operationObj.product_target.net_asset_value_date = new Date();
      }

      // Se obtienen las operaciones finalizadas de los productos
      const cfgAccountOperations = {};
      cfgAccountOperations.params = {};
      cfgAccountOperations.params['$filter'] = `{"operation_status":[{"in": "FINALIZED" }],"key_product":[{"in": "${product.key_name
        }" }]}`;
      this.$accountsService
        .getAccountOperations(this.newOperationState.account.uuid, cfgAccountOperations)
        .then(res => {
          this.newOperationState.targetIsSuccesiveOperation = res.data.related_operations.length > 0;
        })
        .catch(() => {
          // Si hay error, asumimos que no es sucesiva
          this.newOperationState.targetIsSuccesiveOperation = false;
        });
    },

    handlePensionPlansSearch(value, field) {
      this.isLoadingPensionPlans = true;
      const requestConfig = {
        params: {
          [field]: value
        }
      };
      this.$accountsService
        .listPensionPlansData(requestConfig)
        .then(response => (this.pensionPlansSearchResults = response.data.plans))
        .catch(error => console.error(error))
        .finally(() => (this.isLoadingPensionPlans = false));
    },

    handlePensionPlanSelection(selectedPlan) {
      this.newOperationState.operationObj.pp_xt_dgs_code = selectedPlan.pension_plan_dgsfp;
      this.newOperationState.operationObj.pp_xt_egs_code = selectedPlan.managing_entity_dgsfp;
      this.newOperationState.operationObj.xt_fund_name = selectedPlan.pension_plan_name;
    },

    /**
     * Listen isin/name selector inputs
     * @param {Object} query of search
     * @param {String} filterBy typing input
     */
    onSearchObjectChange(query, filterBy) {
      clearTimeout(this.timeOutSearch);
      this.multiselectIsLoading = true;
      this.newOperationState.operationObj.cnmvObject = null;
      this.searchResults = [];
      if (!query) {
        return;
      }
      this.timeOutSearch = setTimeout(() => {
        const actualIsin = this.newOperationState.operationObj.xt_isin_code;
        const actualGestor = this.newOperationState.operationObj.xt_gestor;
        const actualProvider = this.newOperationState.operationObj.xt_provider_official_reg_number;
        const cfg = {
          params: {}
        };
        const q = [];
        q[0] = query;
        this.lastSearch = q;
        this.newOperationState.operationObj.xt_isin_code = null;
        this.newOperationState.operationObj.xt_gestor = null;

        if (filterBy === 'isin') {
          cfg.params['$filter'] = `{"isin":[{"in": "%${q}%" }]}`;
        } else if (filterBy === 'name') {
          cfg.params['$filter'] = `{"name":[{"in": "%${q}%" }]}`;
        }

        this.$accountsService.getCnmvData(cfg).then(res => {
          if (this.lastSearch === q) {
            this.searchResults = res.data.cnmv_data.filter(
              fund => !this.newOperationState.productList.some(p => p.isin_code === fund.isin)
            );
            this.multiselectIsLoading = false;

            // Al editar el traspaso buscamos los valores de la operación en los menús correspondientes si existen
            // Si no existen activamos la introducción manual
            if (this.newOperationState.isEdition) {
              if (this.searchResults.length < 1) {
                this.newOperationState.operationObj.xt_isin_code = actualIsin;
                this.newOperationState.operationObj.xt_gestor = actualGestor;
                this.newOperationState.operationObj.xt_provider_official_reg_number = actualProvider;
                this.isCustomFund = true;
              } else {
                let selectedMarketerNif = null;
                if (this.newOperationState.operationObj.selectedMarketer.nif) {
                  selectedMarketerNif = this.newOperationState.operationObj.selectedMarketer.nif;
                }
                this.onSelectSearch(this.searchResults[0]);

                if (selectedMarketerNif) {
                  const marketer = this.newOperationState.operationObj.cnmvObject.marketers.filter(
                    m => m.nif === selectedMarketerNif
                  )[0];
                  this.onSelectMarketer(marketer);
                }
              }
            }
          }
        });
      }, this.timeOutSearchTime);
    },
    /**
     * @param {Object} fund selected on search
     */
    onSelectSearch(fund) {
      // Preserve NRBE value when in edit mode
      const currentNrbe = this.newOperationState.operationObj.xt_provider_official_reg_number;
      const shouldPreserveNrbe = this.newOperationState.isEdition && currentNrbe;

      this.newOperationState.operationObj.cnmvObject = fund;
      this.newOperationState.operationObj.xt_isin_code = this.newOperationState.operationObj.cnmvObject.isin;
      this.newOperationState.operationObj.xt_fund_official_reg_number = (this.newOperationState.operationObj.cnmvObject.isin).startsWith('ES') ? this.newOperationState.operationObj.cnmvObject.cnmv : this.newOperationState.operationObj.xt_fund_official_reg_number;
      this.newOperationState.operationObj.xt_gestor_official_reg_number = (this.newOperationState.operationObj.cnmvObject.isin).startsWith('ES') ? this.newOperationState.operationObj.cnmvObject.gestor_cnmv : this.newOperationState.operationObj.xt_gestor_official_reg_number;
      if (this.newOperationState.operationObj.cnmvObject.marketers) {
        this.newOperationState.operationObj.cnmvObject.marketers.sort(this.compare);
      }
      this.newOperationState.operationObj.xt_fund_name = this.newOperationState.operationObj.cnmvObject.name;
      this.newOperationState.operationObj.xt_fund_nif = this.newOperationState.operationObj.cnmvObject.fund_nif;
      this.newOperationState.operationObj.xt_gestor = this.newOperationState.operationObj.cnmvObject.gestor_name;
      this.newOperationState.operationObj.xt_gestor_nif = this.newOperationState.operationObj.cnmvObject.gestor_nif;
      this.newOperationState.operationObj.xt_provider = null;

      // Preserve NRBE value in edit mode, otherwise auto-fill from VDOS (bed/regd for ES funds, snce if single marketer for foreign funds)
      const singleMarketer = this.newOperationState.operationObj.cnmvObject.marketers && this.newOperationState.operationObj.cnmvObject.marketers.length === 1
        ? this.newOperationState.operationObj.cnmvObject.marketers[0]
        : null;
      this.newOperationState.operationObj.xt_provider_official_reg_number = shouldPreserveNrbe
        ? currentNrbe
        : (this.newOperationState.operationObj.cnmvObject.nrbe || (singleMarketer ? singleMarketer.snce : null) || null);

      this.newOperationState.operationObj.xt_provider_nif = singleMarketer ? singleMarketer.nif : null;
      this.newOperationState.operationObj.selectedMarketer = singleMarketer;
    },
    /**
     * @param {Object} marketer selected on search
     */
    onSelectMarketer(marketer) {
      this.newOperationState.operationObj.selectedMarketer = marketer;
      this.newOperationState.operationObj.xt_provider = this.newOperationState.operationObj.selectedMarketer.name;
      this.newOperationState.operationObj.xt_provider_nif = this.newOperationState.operationObj.selectedMarketer.nif;
      
      if (!this.newOperationState.isEdition) {
        this.newOperationState.operationObj.xt_provider_official_reg_number = marketer.snce;
      }
    },
    /**
     * @override
     */
    clearFundData() {
      if (this.newOperationState.isEdition && this.multiselectIsLoading) {
        return;
      }

      // Preserve NRBE value when in edit mode
      const preserveNrbe = this.newOperationState.isEdition && this.newOperationState.operationObj.xt_provider_official_reg_number;
      const nrbeValue = preserveNrbe ? this.newOperationState.operationObj.xt_provider_official_reg_number : null;

      this.newOperationState.operationObj.cnmvObject = null;
      this.newOperationState.operationObj.xt_isin_code = null;
      this.newOperationState.operationObj.xt_fund_name = null;
      this.newOperationState.operationObj.xt_fund_official_reg_number = null;
      this.newOperationState.operationObj.xt_fund_nif = null;
      this.newOperationState.operationObj.xt_gestor = null;
      this.newOperationState.operationObj.xt_gestor_official_reg_number = null;
      this.newOperationState.operationObj.xt_gestor_nif = null;
      this.newOperationState.operationObj.xt_provider = null;
      this.newOperationState.operationObj.xt_provider_official_reg_number = nrbeValue;
      this.newOperationState.operationObj.xt_provider_nif = null;
      this.newOperationState.operationObj.selectedMarketer = null;
      this.gestorFieldKey++;
    },
    /**
     * Retrieve bank accounts data
     */
    getBankAccountsData() {
      this.$accountsService.getAccountBankAccounts(this.newOperationState.account.uuid, {}).then(res => {
        const fake = { iban_code: 'Nueva cuenta', is_fake: true };
        this.newOperationState.account.bankAccounts = res.data.bank_accounts;
        this.newOperationState.account.bankAccounts = res.data.bank_accounts;
        this.newOperationState.account.bankAccounts.push(fake);
        this.newOperationState.bankAccount = null;
        this.updatesCount++;
      });
    },
    /**
     * Handle new account
     * @param {Object} selectedBankAccount selectedAccount
     */
    onNewAccount(selectedBankAccount) {
      if (selectedBankAccount.is_fake) {
        this.newOperationState.bankAccount = null;
        const item = {
          active: true,
          name: this.newOperationState.account.id_object,
          route: {
            name: 'accounts_uuid',
            params: {
              uuid: this.newOperationState.account.uuid
            },
            force: true
          }
        };
        localStorage.setItem(`tabs_account_${this.newOperationState.account.uuid}`, 4);
        this.setMenuTab(item);
      } else {
        this.newOperationState.operationObj.xt_account_origin = selectedBankAccount.iban_code;
      }
    },
    setTotalTransfer() {
      if (this.newOperationState.operationObj.is_total_transfer) {
        this.newOperationState.amountSharesIndicator = null;
        this.newOperationState.operationObj.grossAmount = null;
      }
    },
    onChangeRightsType(rightsType) {
      if (rightsType.key === 'C') {
        this.newOperationState.pp_xt_collection_method = '00';
      }
    },
    compare(a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    }
  },
  /**
   * @override
   */
  beforeMount() {
    this.loadProducts();
    this.newOperationState.source = 'PRESENCIAL';

    if (this.transferType === 'internal') {
      this.newOperationState.maxSharesToRefund = this.newOperationState.account.products[
        this.newOperationState.productSelected.key_name
      ].shares;
    }

    if (this.newOperationState.isEdition) {
      switch (this.newOperationState.amountSharesIndicator.key) {
        case 'B':
          this.onInputGrossAmount(this.newOperationState.operationObj.grossAmount);
          break;
        case 'P':
          this.onInputShares(this.newOperationState.operationObj.shares);
          break;
        default:
          break;
      }

      this.onSearchObjectChange(this.newOperationState.operationObj.cnmvObject.isin, 'isin');
    }
  }
};
